import { IDefectRating } from '@/models/IDefectNotice';
import { Api } from '@/plugins/api';
import { Toast } from '@/plugins/toast';
import { EventBus, Event } from '@/plugins/bus';

export const DefectRatingsStore = {
    data: {
        sources: null as IDefectRating[] | null
    },
    methods: {
        updateList(data: []) {
            DefectRatingsStore.data.sources = data;
            EventBus.$emit(Event.DefectRatingsUpdated, data);
        },

        async getData() {
            try {
                if (DefectRatingsStore.data.sources != null) {
                    return DefectRatingsStore.data.sources;
                }
                const response = await Api.get(`defect-ratings`);
                DefectRatingsStore.methods.updateList(response.data);
                return response.data;
            } catch (error) {
                Toast.error('There was an error getting defect ratings');
                return null;
            }
        }
    }
};
